(() => {
  const selector = '[data-kfa-back-to-top]';
  const supportedPageSelector = 'section.okd-grid, [data-kfa-exhibition-story], [data-kfa-exhibition-continuation]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = null;
  let observer = null;

  const bindButton = (button) => {
    if (button.dataset.kfaTopBound === '1') return;
    button.dataset.kfaTopBound = '1';
    button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    });
  };

  const sync = () => {
    frame = null;

    const buttons = Array.from(document.querySelectorAll(selector));
    if (!buttons.length) return;

    const supported = Boolean(document.querySelector(supportedPageSelector));
    const visible = supported && window.scrollY > 96;

    buttons.forEach((button) => {
      bindButton(button);
      button.hidden = !supported;
      button.classList.toggle('is-visible', visible);
    });
  };

  const scheduleSync = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(sync);
  };

  const start = () => {
    if (!observer && document.body) {
      observer = new MutationObserver(scheduleSync);
      observer.observe(document.body, { childList: true, subtree: true });
    }

    scheduleSync();
  };

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync);
  window.addEventListener('pageshow', scheduleSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
